import { FC, SVGAttributes } from 'react';

const ArrowUp: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons/Arrow Up 24x24">
                <g id="Arrow - Up">
                    <path
                        id="Stroke 1"
                        d="M11.7266 4.25L11.7266 19.25"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke 3"
                        d="M5.701 10.3008L11.725 4.25078L17.75 10.3008"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    );
};

export default ArrowUp;
